'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n'], ['\n    ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _metrixCommon = require('metrix-common');

var _Component = require('../Component');

var _Component2 = _interopRequireDefault(_Component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContainerComponent = (0, _styledComponents2.default)(_metrixCommon.Container)(_templateObject, function (_ref) {
    var type = _ref.type;
    return type === 'card' && '\n        border: 1px solid ' + _metrixCommon.Colors.cello45 + ';\n        border-radius: 10px;\n        margin-bottom: 30px;\n        overflow: hidden;\n    ';
});

var WorkflowContainer = function (_React$Component) {
    _inherits(WorkflowContainer, _React$Component);

    function WorkflowContainer() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, WorkflowContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = WorkflowContainer.__proto__ || Object.getPrototypeOf(WorkflowContainer)).call.apply(_ref2, [this].concat(args))), _this), _this.getReturns = function (component, returns) {
            var payload = null;

            if (returns) {
                if (component.type === 'dateRange') {
                    payload = [];
                    if (returns.some(function (x) {
                        return x.code === component.code + 'Start';
                    })) {
                        payload.push(returns.find(function (x) {
                            return x.code === component.code + 'Start';
                        }));
                    }
                    if (returns.some(function (x) {
                        return x.code === component.code + 'End';
                    })) {
                        payload.push(returns.find(function (x) {
                            return x.code === component.code + 'End';
                        }));
                    }
                    if (payload.length === 0) {
                        payload = null;
                    }
                } else {
                    if (returns.some(function (x) {
                        return x.code === component.code;
                    })) {
                        payload = returns.find(function (x) {
                            return x.code === component.code;
                        });
                    }
                }
            }

            return payload;
        }, _this.trackAnalytics = function () {
            var _this$props = _this.props,
                stepAnalytics = _this$props.stepAnalytics,
                container = _this$props.container,
                returns = _this$props.returns,
                analytics = _this$props.analytics;


            if (stepAnalytics && stepAnalytics.pageEventCode && stepAnalytics.elementsToTrack && stepAnalytics.elementsToTrack.length > 0) {
                var gaData = {};

                stepAnalytics.elementsToTrack.forEach(function (trackedElement) {
                    var component = container.components.find(function (c) {
                        return c.code === trackedElement.elementCode;
                    });
                    var returnObject = returns.find(function (r) {
                        return r.code === trackedElement.elementCode;
                    });

                    if (component && returnObject) {
                        if (trackedElement.values && Array.isArray(trackedElement.values) && trackedElement.values.length > 0) {
                            // Handle Compound Component case
                            trackedElement.values.forEach(function (valueCode, index) {
                                var valueElement = returnObject.elements.find(function (e) {
                                    return e.code === valueCode;
                                });
                                if (valueElement && Array.isArray(trackedElement.gtmCodes) && trackedElement.gtmCodes[index]) {
                                    var gtmCode = trackedElement.gtmCodes[index];
                                    gaData[gtmCode] = valueElement.value;
                                }
                            });
                        } else {
                            var valueElement = returnObject.elements.find(function (e) {
                                return e.code === 'Value';
                            });
                            if (valueElement && Array.isArray(trackedElement.gtmCodes)) {
                                trackedElement.gtmCodes.forEach(function (gtmCode) {
                                    if (gtmCode) {
                                        gaData[gtmCode] = valueElement.value;
                                    }
                                });
                            }
                        }
                    }
                });

                if (Object.keys(gaData).length > 0) {
                    analytics.track(stepAnalytics.pageEventCode, gaData);
                }
            }
        }, _this.getContainers = function (container) {
            var isMobile = _this.context.screen.isMobile;

            if (container.containers) {
                return _react2.default.createElement(
                    _metrixCommon.Container,
                    null,
                    container.containers.map(function (nested) {
                        return _this.getContainers(nested);
                    })
                );
            } else {
                var componentProps = {
                    context: _this.props.context,
                    configuration: _this.props.configuration,
                    session: _this.props.session,
                    culture: _this.props.culture,
                    type: _this.props.container.type,
                    valid: _this.props.valid,
                    doSetReturn: _this.props.doSetReturn,
                    doStep: _this.props.doStep,
                    reference: _this.props.reference,
                    doReduceDynamicDate: _this.props.doReduceDynamicDate,
                    doExecuteAction: _this.props.doExecuteAction,
                    entity: _this.props.entity,
                    returns: _this.props.returns,
                    trackAnalytics: _this.trackAnalytics,
                    workflowConfiguration: _this.props.workflowConfiguration
                };
                return _this.props.container.type === 'card' ? _react2.default.createElement(
                    _metrixCommon.Grid,
                    null,
                    _react2.default.createElement(
                        _metrixCommon.Row,
                        null,
                        _react2.default.createElement(_metrixCommon.Column, { xs: 1,
                            md: 2
                        }),
                        _react2.default.createElement(
                            _metrixCommon.Column,
                            { xs: 10,
                                md: 8
                            },
                            _react2.default.createElement(
                                ContainerComponent,
                                { type: _this.props.container.type },
                                container.components.map(function (nested) {
                                    return _react2.default.createElement(_Component2.default, _extends({ key: nested.code,
                                        component: nested,
                                        'return': _this.getReturns(nested, _this.props.returns)
                                    }, componentProps));
                                })
                            )
                        ),
                        _react2.default.createElement(_metrixCommon.Column, { xs: 1,
                            md: 2
                        })
                    )
                ) : _react2.default.createElement(
                    ContainerComponent,
                    { type: _this.props.container.type },
                    container.components.map(function (nested) {
                        return _react2.default.createElement(_Component2.default, _extends({ key: nested.code,
                            component: nested,
                            inline: isMobile,
                            'return': _this.getReturns(nested, _this.props.returns)
                        }, componentProps));
                    })
                );
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WorkflowContainer, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _metrixCommon.Container,
                null,
                this.getContainers(this.props.container)
            );
        }
    }]);

    return WorkflowContainer;
}(_react2.default.Component);

WorkflowContainer.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = WorkflowContainer;